export default "__VITE_ASSET__B0tQsC66__"